import React, { useState, useCallback, useEffect } from 'react';
import { Input, Avatar, Icon, AutoComplete, message, Tooltip } from 'antd';
import styles from './selectTenant.module.scss';
import debounce from 'lodash/debounce';
import * as apis from '@/apis';

function renderOption(item, idx) {
  return (
    <AutoComplete.Option key={item._id}>
      <Avatar shape="square" size={24} src={item.logo} />
      <span> {item.short_name}</span>
    </AutoComplete.Option>
  );
}

function renderEmpty() {
  const emptyInfo = (
    <AutoComplete.Option key="disabled" disabled>
      <span>无匹配项</span>
    </AutoComplete.Option>
  );
  return [emptyInfo];
}

export default function SelecTenant({
  onChange,
  placeholder,
  value: initialValue = null,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [data, setData] = useState();
  const [list, setList] = useState([]);
  const handleSearch = useCallback(
    debounce(async (value) => {
      setFetching(true);
      try {
        const result = await apis.searchTenant(value);
        setFetching(false);
        setList(result.data);
      } catch (error) {
        setFetching(false);
        message.info(error.message || '接口异常');
      }
    }, 800),
    []
  );
  const resetValue = useCallback(() => {
    setData(null);
    onChange && onChange(null);
  }, []);
  const onSelect = useCallback(
    (value) => {
      const selected = list.find((item) => item._id === value);
      setData(selected);
      onChange && onChange(selected._id);
    },
    [list]
  );
  const init = useCallback(async () => {
    if (initialValue && !data) {
      const tenant = await apis.getTenantById(initialValue);
      setData(tenant);
    }
  }, [initialValue, data]);

  useEffect(() => {
    init();
  }, []);

  if (data) {
    return (
      <Input
        addonBefore={
          <Avatar size={24} className={styles.avatar} src={data.logo}></Avatar>
        }
        addonAfter={
          <Tooltip title="解除">
            <Icon type="close-circle" onClick={resetValue} />
          </Tooltip>
        }
        disabled
        value={data.short_name}
        style={props.style || {}}
      />
    );
  }

  return (
    <div style={props.style || {}}>
      <AutoComplete
        dataSource={list.length ? list.map(renderOption) : renderEmpty()}
        onSearch={handleSearch}
        onSelect={onSelect}
      >
        <Input.Search placeholder={placeholder} loading={fetching} />
      </AutoComplete>
    </div>
  );
}
